import { InventoryStatus } from '@hungryroot/rest';
import { Warning as WarningIcon, Paragraph } from '@hungryroot/ui-kit';
import styles from './WarningCallout.module.css';

export enum WarningCalloutVariant {
  Restrictions = 'restrictions',
  Never = 'never',
  OutOfStock = 'oos',
}

interface WarningCalloutProps {
  testid?: string;
  status?: InventoryStatus;
  variant: WarningCalloutVariant;
  text: string;
}

export function WarningCallout(props: WarningCalloutProps) {
  const { testid, variant, text, status } = props;
  return (
    <div data-testid={testid} className={styles[variant]}>
      {status !== InventoryStatus.OutOfStock && <WarningIcon />}
      <Paragraph variant="caption">{text}</Paragraph>
    </div>
  );
}
